import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbPreferenceService {
  private readonly storageKey = 'agent-show-breadcrumbs';
  private showBreadcrumbsSubject = new BehaviorSubject<boolean>(this.loadPreference());
  showBreadcrumbs$: Observable<boolean> = this.showBreadcrumbsSubject.asObservable();

  constructor() {}

  getShowBreadcrumbs(): boolean {
    return this.showBreadcrumbsSubject.value;
  }

  setShowBreadcrumbs(show: boolean): void {
    this.showBreadcrumbsSubject.next(show);
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(show));
    } catch (error) {
      console.warn('[BreadcrumbPreferenceService] Failed to persist preference:', error);
    }
  }

  private loadPreference(): boolean {
    try {
      const stored = localStorage.getItem(this.storageKey);
      if (stored === null) {
        // Default to true (show breadcrumbs by default)
        return true;
      }
      return JSON.parse(stored) === true;
    } catch (error) {
      console.warn('[BreadcrumbPreferenceService] Failed to load preference:', error);
      return true; // Default to true
    }
  }
}
